import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { CityDetailForm } from "@/features/city/CityDetailForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function CityDetail() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/city",
            label: "City (Kota/Kab)",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>City (Kota/Kab) Detail</H2>
      <CityDetailForm id={id} />
    </>
  );
}
